export const UI_THEME_STORAGE_KEY = 'respark-editor-ui-theme';
export const UI_THEME_EVENT = 'respark-editor-theme';
export const UI_THEME_HTML_ATTR = 'data-respark-ui-theme';

export const UI_THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
} as const;

export type UiTheme = (typeof UI_THEMES)[keyof typeof UI_THEMES];

export function normalizeUiTheme(value: unknown): UiTheme {
  return value === UI_THEMES.LIGHT ? UI_THEMES.LIGHT : UI_THEMES.DARK;
}

export function readStoredUiTheme(): UiTheme {
  try {
    return normalizeUiTheme(localStorage.getItem(UI_THEME_STORAGE_KEY));
  } catch {
    return UI_THEMES.DARK;
  }
}

/** Sync tokens to <html> so portaled flyouts/menus inherit theme variables. */
export function applyDocumentUiTheme(theme: UiTheme): void {
  if (typeof document === 'undefined') {
    return;
  }
  const root = document.documentElement;
  root.setAttribute(UI_THEME_HTML_ATTR, theme);
  root.classList.remove('respark-theme-light', 'respark-theme-dark');
  root.classList.add(uiThemeClassName(theme));
}

export function persistUiTheme(theme: UiTheme): void {
  try {
    localStorage.setItem(UI_THEME_STORAGE_KEY, theme);
  } catch {
    /* ignore quota / private mode */
  }
  applyDocumentUiTheme(theme);
  window.dispatchEvent(
    new CustomEvent(UI_THEME_EVENT, { detail: theme }),
  );
}

export function uiThemeClassName(theme: UiTheme): string {
  return theme === UI_THEMES.LIGHT ? 'respark-theme-light' : 'respark-theme-dark';
}
